module.exports = __webpack_public_path__ + "saira-semibold-webfont.0d7646e0dc7cbc529dea.woff";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/saira-semibold-webfont.woff
// module id = ../../../../../src/assets/fonts/saira-semibold-webfont.woff
// module chunks = styles